import React, { FC, useState } from "react";
import { IconButton, Menu } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { ApplicationFeature } from "@green0meter/api-client";

import { CsvImport } from "./components/CsvImport";
import CsvExport from "./components/CsvExport";
import Synchronize from "./components/Synchronize";
import { PSASImport } from "./components/PSASImport";
import { AIImport } from "./components/AIImport";
import FormConfigExport from "./components/FormConfigExport";
import FormConfigImport from "./components/FormConfigImport";

import { Box } from "@components/base";
import { useUserStore } from "@store/user";
import { useGetCurrentCompanyInfo } from "@api";
import { hasFeature } from "@helpers";
import { useMultistepFormStore } from "@components/common/MultistepForm";

interface ActionsDropdown {}

const ActionsDropdown: FC<ActionsDropdown> = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { user } = useUserStore();
  const { currentCompanyInfo } = useGetCurrentCompanyInfo(user);
  const {
    formSettings: { editMode },
  } = useMultistepFormStore();

  const handleOpen = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const hasPSASFeature = hasFeature(
    currentCompanyInfo?.companyFeatureFunctionalities,
    ApplicationFeature.PSAS,
  );

  return (
    <Box>
      <IconButton onClick={handleOpen}>
        <MoreHoriz />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {!editMode && (
          <>
            <CsvExport />
            <CsvImport />
            <AIImport />
            {hasPSASFeature && <PSASImport />}
            <Synchronize />
          </>
        )}
        {editMode && (
          <>
            <FormConfigExport />
            <FormConfigImport />
          </>
        )}
      </Menu>
    </Box>
  );
};

export default ActionsDropdown;
